export const getWeightUoMOptions = () => {
  return [
    { id: 'LBS', label: 'lbs' },
    {
      id: 'KGS',
      label: 'kg',
    },
  ];
};
